import Vue from 'vue'
import vConsole from './vconsole'
import 'amfe-flexible'
import 'postcss-pxtorem'
import i18n from './i18n'
import adapter from './adapter' //如果是pc设备更改根字体的fontsize
import App from './App.vue'
// 核心插件
import tccc from '@/plugin/tccc'

import router from './router'
import store from './store'
// 引入
import '@/icons'
import '@/assets/fonts/material-icons.css'
import fontLoader from '@/utils/fontLoader'
import { Toast } from 'vant'
import * as api from '@/api/modules/api'
import '@vant/touch-emulator'
import util from '@/libs/util'
import clientConfig from '@/config/clientConfig'

Vue.use(Toast)

// 核心插件
Vue.use(tccc)

// 获取当前客户和环境
const clientId = process.env.VUE_APP_CLIENT_NAME
const env = process.env.NODE_ENV

// 初始化客户配置
const config = clientConfig.init(clientId, env)
console.log(config, 'config')
// 设置全局变量
Vue.prototype.$clientConfig = clientConfig

// // 设置环境变量
// process.env.VUE_APP_API_HOST = config.api.host
// process.env.VUE_APP_PUBLIC_PATH = config.build.publicPath
// process.env.VUE_APP_PM_ENABLED = config.build.pmEnabled
// process.env.VUE_APP_VERSION = config.build.version
// process.env.VUE_APP_I18N_LOCALE = config.i18n.locale
// process.env.VUE_APP_I18N_FALLBACK_LOCALE = config.i18n.fallbackLocale

// if (config.env === 'production') {
//   process.env.VUE_APP_SCOURCE_LINK = config.build.sourceLink
//   process.env.VUE_APP_BUILD_MODE = config.build.buildMode
// }

Vue.config.productionTip = false
new Vue({
   i18n,
   router,
   store,
   render: (h) => h(App),
   beforeCreate() {
      // 用户登录后从数据库加载一系列的设置
      this.$store.dispatch('tccc/account/load')
      console.log(this.$store.state.tccc.user.info.userid, '1')
   },

   watch: {
      // 检测路由变化切换侧边栏内容
      '$route.matched': {
         handler(matched) {
            if (util.cookies.get('Access_Token') && util.cookies.get('appid')) {
               let data = {
                  ad_uid: '',
                  client_id: '',
                  need_cache: 0,
                  data: {
                     // signature_url: window.decodeURIComponent(
                     //    window.top.location.href
                     // ),
                     signature_url: window.top.location.href,
                     js_api_list: [
                        'checkJsApi',
                        'launchMiniprogram',
                        'getContext',
                        'openUserProfile',
                        'selectEnterpriseContact',
                        'getCurCorpGroupContact',
                        'getCurCorpGroupChat',
                        'getCurExternalContact',
                        'selectCorpGroupContact',
                        'openDefaultBrowser',
                        'selectExternalContact',
                        'setKeepScreenOn'
                     ],
                  },
               }

               api.jsapiTicket(data).then((res) => {
                  if (
                     res.status_code == 0 &&
                     res.data &&
                     res.data.timestamp &&
                     res.data.nonceStr &&
                     res.data.corpid &&
                     res.data.signature_raw &&
                     res.data.signature
                  ) {
                     window.top.wx.agentConfig({
                        // beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
                        // debug: 1, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        // appId: res.data.corpid, // 必填，企业微信的corpID，必须是本企业的corpID，不允许跨企业使用
                        // timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                        // nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                        // signature: res.data.signature,// 必填，签名，见 附录-JS-SDK使用权限签名算法
                        // jsApiList: ['chooseImage'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
                        beta: true,
                        debug: true,
                        corpid: res.data.corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
                        agentid: res.data.agentid, //'1000007', // 必填，企业微信的应用id （e.g. 1000247）
                        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                        nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                        signature: res.data.signature, // 必填，签名，见附录-JS-SDK使用权限签名算法
                        jsApiList: res.data.jsApiList, //必填，传入需要使用的接口名称
                        success: function (res) {
                           //检测api权限是否正常
                           window.top.wx.checkJsApi({
                              jsApiList: data.data.js_api_list, // 需要检测的JS接口列表，所有JS接口列表见附录2,
                              success: function (res) {
                                 // console.log(
                                 //    res,
                                 //    'resresresresresresresresresresresresresresresres'
                                 // )
                                 // Toast.success(res)
                              },
                              error: function (res) {
                                 Toast({
                                    type: 'fail',
                                    message: `ERROR: ${JSON.stringify(res)}`,
                                    duration: 3000,
                                 })
                              },
                           })
                        },
                        fail: function (res) {
                           if (res.errMsg.indexOf('function not exist') > -1) {
                              Toast({
                                 type: 'fail',
                                 message: '版本过低请升级!',
                                 duration: 3000,
                              })
                           }
                           // info('wx.agentConfig Error！:' + JSON.stringify(res, null, 2))
                        },
                     })
                  } else {
                     Toast({
                        type: 'fail',
                        message: 'ticket获取失败!',
                        duration: 3000,
                     })
                  }
               })
            }
         },
         immediate: true,
         deep: true, //深度监视
      },
   },
}).$mount('#app')

// 加载Material Icons字体
fontLoader.loadMaterialIcons().then(() => {
  console.log('Material Icons字体加载完成')
}).catch((error) => {
  console.error('Material Icons字体加载失败:', error)
})
